<template>
  <div>
    <b-table
        ref="catalogTable"
        striped
        hover
        :empty-text="$t('components.bootstrap_table.empty_text')"
        :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
        :fields="fields"
        :items="getCatalog"
        :per-page="query.perPage"
        :sort-by="query.sortBy"
        :sort-desc="query.sortDesc"
        :current-page="query.page"
        show-empty
        :stacked="$store.state.app.isMobile"
        :filter="query.filter"
    >

      <template v-slot:cell(image_url)="data">
        <b-avatar rounded :src="data.item.image_url" size="4rem"></b-avatar>
      </template>

      <template v-slot:cell(status)="data">
        <f-badge size="md" :variant="statusEnum[data.item.status].variant">{{
            statusEnum[data.item.status].text
          }}
        </f-badge>
      </template>

      <template v-slot:cell(item_name)="data">
        <h5 class="font-size-13 text-truncate item-name">
          {{ data.item.item_name }}
        </h5>
      </template>

      <template v-slot:cell(marketplace_id)="data">
        <market-place-chip :marketPlaceId="data.item.marketplace_id"></market-place-chip>
      </template>

    </b-table>
    <div class="row">
      <div class="col-sm">
        <Pagination v-model="query.page" :meta="catalog.meta"></Pagination>
      </div>
    </div>
  </div>

</template>

<script>
import MarketPlaceChip from "../../../components/widgets/MarketPlaceChip";

export default {
  name: "CatalogList",
  components: {MarketPlaceChip},
  props: {
    catalog: {
      type: Object,
      Default: {}
    },
    fetchFunction: {
      type: Function,
    },
    query: {}
  },
  data() {
    return {
      fields: [
        {key: 'image_url', sortable: false, label: this.$t('pages.catalog.fields.image')},
        {key: 'asin1', sortable: false, label: this.$t('pages.catalog.fields.asin')},
        {key: 'item_name', sortable: false, label: this.$t('pages.catalog.fields.item_name')},
        {key: 'quantity', sortable: false, label: this.$t('pages.catalog.fields.quantity')},
        {key: 'price', sortable: false, label: this.$t('pages.catalog.fields.price')},
        {key: 'status', sortable: false, label: this.$t('pages.catalog.fields.status')},
        {key: 'open_date', sortable: false, label: this.$t('pages.catalog.fields.open_date')},
        {key: 'marketplace_id', sortable: false, label: 'Marketplace'},
      ],
      items: [],
      statusEnum: {
        active: {
          variant: 'success',
          text: this.$t('pages.catalog.status.active')
        },
        incomplete: {
          variant: 'info',
          text: this.$t('pages.catalog.status.incomplete')
        },
        inactive: {
          variant: 'danger',
          text: this.$t('pages.catalog.status.inactive')
        }
      }
    }
  },
  methods: {
    async getCatalog(e) {
      await this.fetchFunction(e)
      return this.catalog.data ?? []
    },
    refreshTable() {
      this.$refs.catalogTable.refresh()
    }
  },
}
</script>

<style scoped>
.item-name {
  width: 220px;
}

@media only screen and (max-width: 768px) {
  .item-name {
    width: 180px;
  }
}

</style>